import {
  enterActualsController,
  enterActualsTemplate,
  locationController,
  locationTemplate
} from "../modals"


import moment from 'moment';
import formatCurrency from "format-currency";


class TravelExpenseActualsController {

  constructor(CompanyService, toastr, $scope, $http, $rootScope, $stateParams, $state, $uibModal, TravelExpenseService) {
    "ngInject";

    this.moment = moment;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.state = $state;
    this.$stateParams = $stateParams;
    this.activeUsers = [];
    this.$uibModal = $uibModal;
    this.travelExpense = {
      expenses: []
    };
    this.travelExpenseService = TravelExpenseService
    this.readyForSubmission = false
    this.rejectionBaseline = null

    this.apiHost = $rootScope.apiHost;

    this.expensesToDelete = []

    this.$http.get($rootScope.apiHost+"/api/users/me", {withCredentials: true}).then((response) => {
      this.projects = response.data.projects;
    });

    this.paymentMethods = [
      {
        name: "Corporate",
        value: "corporate"
      },
      {
        name: "Personal",
        value: "personal"
      }];

    this.loading = true
    this.reloadExpenseReport();

    // As travelExpense data changes flag whether or not its ready for submission
    $scope.$watch(() => this.travelExpense, () => {
      this.updateReadyForSubmission();
    }, true)

  }

  buildChangeSnapshot(report) {
    const expenses = (report && report.expenses) ? report.expenses : [];

    return JSON.stringify(
      expenses
        .map((expense) => ({
          id: expense.id || null,
          itinerary: !!expense.itinerary,
          place: expense.place || null,
          fromDate: this.formatApiDate(expense.fromDate),
          toDate: this.formatApiDate(expense.toDate),
          daysTraveled: expense.daysTraveled != null ? Number(expense.daysTraveled) : null,
          mealsRate: expense.mealsRate != null ? Number(expense.mealsRate) : null,
          lodgingRate: expense.lodgingRate != null ? Number(expense.lodgingRate) : null,
          type: expense.type || null,
          description: expense.description || null,
          amount: expense.amount != null ? Number(expense.amount) : null,
          actualAmount: expense.actualAmount != null ? Number(expense.actualAmount) : null,
          actualLodging: expense.actualLodging != null ? Number(expense.actualLodging) : null,
          paymentMethod: expense.paymentMethod || null,
          billableToProject: !!expense.billableToProject,
          receiptIds: (expense.receipts || [])
            .map((receipt) => receipt.receipt)
            .filter(Boolean)
            .sort()
        }))
        .sort((a, b) => {
          const aId = a.id == null ? 0 : a.id;
          const bId = b.id == null ? 0 : b.id;
          return aId - bId;
        })
    );
  }

  hasUpdatesSinceRejection() {
    if (!this.isReimbursementRejected()) {
      return true;
    }

    if (!this.rejectionBaseline) {
      return false;
    }

    return this.buildChangeSnapshot(this.travelExpense) !== this.rejectionBaseline;
  }

  areExpensesReadyForSubmission() {
    const expenses = this.travelExpense.expenses || [];

    if (!expenses.length) {
      return false;
    }

    return expenses.every((e) => {
      if (e.itinerary && e.actualLodging === 0) {
        return true;
      }

      if (e.itinerary && e.actualLodging > 0 && e.receipts && e.receipts.length > 0) {
        return true;
      }

      if (e.type === 'Personally Owned Vehicle' && e.actualAmount > 0) {
        return true;
      }

      return (e.actualAmount || e.actualAmount > 0) && e.receipts && e.receipts.length > 0 && e.paymentMethod;
    });
  }

  updateReadyForSubmission() {
    this.readyForSubmission = this.areExpensesReadyForSubmission() && this.hasUpdatesSinceRejection();
  }

  getSubmissionBlockedMessage() {
    if (this.isLocked() || this.readyForSubmission) {
      return '';
    }

    if (this.isReimbursementRejected() && !this.hasUpdatesSinceRejection()) {
      return 'Update the itinerary or travel expenses before resubmitting for reimbursement.';
    }

    return 'Complete actual amounts, payment methods, and receipts before submitting for reimbursement.';
  }

  reloadExpenseReport(successToastMessage) {
    this.loading = true;
    return this.$http.get(this.$rootScope.apiHost + "/api/expense-reports/" + this.$stateParams.expenseReportId, {withCredentials: true}).then((success) => {
      this.loading = false;
      const report = this.travelExpenseService.normalizeExpenseReportDates(success.data);
      this.travelExpenseService.hydrateEstimateBasisDisplay(report);
      this.travelExpenseService.hydrateMileageDisplay(report);
      this.travelExpense = report;
      this.travelExpense.expenses = report.expenses || [];
      this.travelExpenseStatusDetails = this.travelExpenseService.getTravelExpenseStatusDetails(this.travelExpense.status);

      if (this.travelExpense.status === 'REIMBURSEMENT_REJECTED') {
        if (!this.rejectionBaseline) {
          this.rejectionBaseline = this.buildChangeSnapshot(this.travelExpense);
        }
      } else {
        this.rejectionBaseline = null;
      }

      this.updateReadyForSubmission();

      if (successToastMessage) {
        this.toastr.success(successToastMessage === true ? 'Actuals saved.' : successToastMessage, 'SUCCESS');
      }

      return report;
    }, () => {
      this.loading = false;
      this.toastr.error('Could not load expense report.', 'ERROR');
    });
  }

  addExpense() {
    this.openEnterActuals(null);
  }

  getItineraryLocations() {
    return (this.travelExpense.expenses || []).filter((expense) => expense.itinerary);
  }

  getAdditionalExpenses() {
    return (this.travelExpense.expenses || []).filter((expense) => !expense.itinerary);
  }

  canRemoveLocation() {
    return this.getItineraryLocations().length > 1;
  }

  formatApiDate(value) {
    if (!value) {
      return null;
    }

    return moment(value).format('YYYY-MM-DD');
  }

  buildLocationPayload(location) {
    return {
      itinerary: true,
      place: location.place,
      zip: location.zip || null,
      fromDate: this.formatApiDate(location.fromDate),
      toDate: this.formatApiDate(location.toDate),
      daysTraveled: location.daysTraveled,
      mealsRate: location.mealsRate || 0,
      lodgingRate: location.lodgingRate || 0,
      type: location.type || null,
      description: location.description || ('Travel to ' + (location.place || 'destination')),
      amount: 0
    };
  }

  openLocationModal(existingLocation) {
    if (this.isLocked()) {
      return;
    }

    const self = this;
    const modalInstance = this.$uibModal.open({
      template: locationTemplate,
      controller: locationController,
      controllerAs: '$ctrl',
      resolve: {
        billableTrip() {
          return self.isBillableTrip();
        },
        existingLocation() {
          return existingLocation || null;
        }
      },
      windowClass: 'hmodal-success'
    });

    modalInstance.addLocationToItinerary = function(location) {
      self.loading = true;
      self.$http
        .post(
          self.$rootScope.apiHost + '/api/expense-reports/' + self.travelExpense.id + '/expenses',
          self.buildLocationPayload(location),
          { withCredentials: true }
        )
        .then(() => {
          return self.reloadExpenseReport('Location added.');
        })
        .catch((err) => {
          console.error('Could not add location:', err);
          self.loading = false;
          self.toastr.error('Could not add location.', 'ERROR');
        });
    };

    modalInstance.updateLocationInItinerary = function(original, updated) {
      if (!original || !original.id) {
        return;
      }

      self.loading = true;
      const payload = self.buildLocationPayload(updated);
      self.$http
        .patch(
          self.$rootScope.apiHost + '/api/expense-reports/' + self.travelExpense.id + '/expenses/' + original.id,
          {
            place: payload.place,
            zip: payload.zip,
            fromDate: payload.fromDate,
            toDate: payload.toDate,
            daysTraveled: payload.daysTraveled,
            mealsRate: payload.mealsRate,
            lodgingRate: payload.lodgingRate,
            itinerary: true,
            description: payload.description
          },
          { withCredentials: true }
        )
        .then(() => {
          return self.reloadExpenseReport('Itinerary updated.');
        })
        .catch((err) => {
          console.error('Could not update location:', err);
          self.loading = false;
          self.toastr.error('Could not update location.', 'ERROR');
        });
    };
  }

  addLocation() {
    this.openLocationModal(null);
  }

  editLocation(location) {
    this.openLocationModal(location);
  }

  removeLocation(location) {
    if (this.isLocked() || !location || !location.id) {
      return;
    }

    if (!this.canRemoveLocation()) {
      this.toastr.warning('At least one itinerary location is required.', 'Cannot Remove');
      return;
    }

    this.loading = true;
    this.$http
      .delete(
        this.$rootScope.apiHost + '/api/expense-reports/' + this.travelExpense.id + '/expenses/' + location.id,
        { withCredentials: true }
      )
      .then(() => {
        return this.reloadExpenseReport('Location removed.');
      })
      .catch((err) => {
        console.error('Could not remove location:', err);
        this.loading = false;
        this.toastr.error('Could not remove location.', 'ERROR');
      });
  }

  openEnterActuals(expense) {
    if (this.isLocked()) {
      return;
    }

    const self = this;
    const modalInstance = this.$uibModal.open({
      template: enterActualsTemplate,
      controller: enterActualsController,
      controllerAs: '$ctrl',
      resolve: {
        expenseReport() {
          return self.travelExpense;
        },
        expense() {
          return expense || null;
        },
        paymentMethods() {
          return self.paymentMethods;
        }
      },
      windowClass: 'hmodal-success'
    });

    modalInstance.result.then((result) => {
      const message = (result && result.created) ? 'Expense added.' : 'Actuals saved.';
      self.reloadExpenseReport(message);
    });
  }

  hasEnteredActuals(expense) {
    if (!expense) {
      return false;
    }

    if (expense.itinerary) {
      return expense.actualLodging != null;
    }

    return expense.actualAmount != null;
  }

  getActualAmountDisplay(expense) {
    if (!expense) {
      return '$ -';
    }

    if (expense.itinerary) {
      return this.currency(expense.actualLodging) || '$ -';
    }

    return this.currency(expense.actualAmount) || '$ -';
  }

  getPaymentMethodLabel(expense) {
    if (!expense) {
      return 'Not Set';
    }

    if (expense.type === 'Personally Owned Vehicle') {
      return 'Personal';
    }

    if (expense.itinerary && (expense.actualLodging == null || expense.actualLodging === 0)) {
      return expense.actualLodging === 0 ? 'N/A' : 'Not Set';
    }

    if (!expense.paymentMethod) {
      return 'Not Set';
    }

    const match = this.paymentMethods.find((method) => method.value === expense.paymentMethod);
    if (match) {
      return match.name;
    }

    return expense.paymentMethod;
  }

  /**
   * Remove expense locally and keep track of what was removed for later deletion on save.
   *
   * @param {*} expenses
   * @param {*} index
   */
  removeExpense(expenseReportId, expenseId) {

    this.$http
      .delete(
        this.$rootScope.apiHost + "/api/expense-reports/"+expenseReportId+"/expenses/"+expenseId,
        { withCredentials: true }
      )
      .then((success) => {
        this.toastr.success('Successfully removed Expense.', 'SUCCESS');
        this.travelExpense.expenses = success.data;
      })
      .catch((err) => {
        console.error('Could not remove Expense:', err);
        this.toastr.error('Could not remove Expense.', 'ERROR');
      });

  }

  cancel(){
    this.state.go(this.isProxyImport() ? 'admin.expenses' : 'expenses');
  }

  isProxyImport() {
    return this.$stateParams.proxyImport === true
      || this.$stateParams.proxyImport === 'true'
      || this.travelExpenseService.isProxyImportEditable(this.travelExpense)
      || !!(this.travelExpense && this.travelExpense.proxyCreatedByUserId);
  }

  isBillableTrip() {
    return this.travelExpense && this.travelExpense.purpose === 'customer';
  }

  getItineraryColumnCount() {
    let count = 4; // location, arrival, departure, days
    if (this.isBillableTrip()) {
      count += 4;
    }
    if (!this.isLocked()) {
      count += 1;
    }
    return count;
  }

  getTravelExpenseColumnCount() {
    let count = 6; // expense, description, estimated, actual, payment, receipt
    if (this.isBillableTrip()) {
      count += 1;
    }
    if (!this.isLocked()) {
      count += 1;
    }
    return count;
  }

  getTravelExpenseTotalsTrailingColspan() {
    // Payment Method + optional Billable + Receipt
    return this.isBillableTrip() ? 3 : 2;
  }

  isReimbursementRejected() {
    return this.travelExpense && this.travelExpense.status === 'REIMBURSEMENT_REJECTED';
  }

  getPurposeLabel() {
    if (!this.travelExpense) {
      return '';
    }

    if (this.travelExpense.purpose === 'customer') {
      return 'In Support of Customer (Billable)';
    }

    if (this.travelExpense.purpose === 'other') {
      return 'Other Business Travel (Non-Billable)';
    }

    return this.travelExpense.purpose || '';
  }

  getProjectLabel() {
    if (!this.travelExpense) {
      return '';
    }

    if (this.travelExpense.projectName) {
      return this.travelExpense.projectName;
    }

    if (this.travelExpense.project && this.travelExpense.project.name) {
      return this.travelExpense.project.name;
    }

    if (this.travelExpense.project) {
      return String(this.travelExpense.project);
    }

    return '';
  }

  hasTravelExpenseRows() {
    const expenses = this.travelExpense.expenses || [];
    if (this.isBillableTrip() && this.travelExpenseService.hasItinerary(this.travelExpense)) {
      return true;
    }

    return expenses.some((expense) => !expense.itinerary);
  }

  isLocked() {
    if (this.travelExpenseService.isProxyImportEditable(this.travelExpense)) {
      return false;
    }
    // Managers opened via ?proxyImport=true may edit any non-processed report.
    const proxyParam = this.$stateParams.proxyImport === true
      || this.$stateParams.proxyImport === 'true';
    if (proxyParam && (this.travelExpense.status || '').toUpperCase() !== 'PROCESSED') {
      return false;
    }
    return !(this.travelExpense.status === 'APPROVED' || this.travelExpense.status === 'REIMBURSEMENT_REJECTED')
  }

  currency(value) {
    if(value != null && value !== '') {
      return '$' + formatCurrency(value);
    } else {
      return undefined;
    }
  }

  submitForReimbursement() {
    if (!this.readyForSubmission) {
      this.toastr.warning(this.getSubmissionBlockedMessage() || 'Unable to submit yet.', 'Incomplete');
      return;
    }

    this.loading = true
    if (this.travelExpense.id) {
      this.travelExpenseService.submitForReimbursement(this.travelExpense).then(() => {
        this.loading = false
        this.state.go(this.isProxyImport() ? 'admin.expenses' : 'expenses')
      }, () => {
        this.loading = false
        this.toastr.error('Could not submit for reimbursement.', 'ERROR');
      })
    }
  }

}

export default TravelExpenseActualsController;



// WEBPACK FOOTER //
// ./client/pages/expenses/travel-expense-actuals/travel-expense-actuals.controller.js